import { Link } from "react-router-dom";
import logo from "@/assets/ocean-exports-logo.png";

// Reusable Logo — official Ocean Exports lockup (icon + wordmark).
export function Logo({ variant = "dark", className = "" }) {
  const img = <img src={logo} alt="Ocean Exports — aftermarket tractor, implement and backhoe loader parts exporter" data-testid="brand-logo" className="h-14 sm:h-16 w-auto object-contain" />;
  return (
    <Link to="/" data-testid="logo-link" className={`inline-flex items-center ${className}`} aria-label="Ocean Exports home">
      {variant === "light" ? (
        <div className="bg-white rounded-md px-3 py-2">{img}</div>
      ) : (
        img
      )}
    </Link>
  );
}
